export default __webpack_public_path__ + "static/media/sv_1.7e6182b5.webp";